module.exports = __webpack_public_path__ + "images/emoji/free.19019afae8d738088f98.png";